document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("zh-active")) {
    const promoContainer = document.querySelector(".grid.site-nav__promo-container");
    const bottomBg = document.querySelector(".megamenu-bottom-bg");

    if (promoContainer && bottomBg) {
      // Move the megamenu-bottom-bg after the promo container
      promoContainer.insertAdjacentElement("afterend", bottomBg);
    }
  }
});
